import { FC, useEffect, useRef, useState } from "react";
import { DisabledTextField, FormHeading, Loading, LoginButton, Option, OptionButton, OptionContainer, OptionInfo, OptionLabel } from "../Styles";

import textIcon from '../../assets/images/text.png';
import emailIcon from '../../assets/images/email.png';
import Lottie from 'react-lottie';
import checkmarkAnimation from '../../assets/images/checkmark.json';
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FormData } from "../../data/interfaces/dataMessage";
import {UserData, NewUserData} from "../../data/interfaces/userInfo";
import FadeLoader from "react-spinners/PulseLoader";
import useHover from "./useHover";


//use later to pass in data
interface MFAOptionProps {
    setFormData:UseFormSetValue<FormData>
    user: NewUserData
    loginPaused: boolean
}

const checkmark = {
    loop: false,
    autoplay: true,
    animationData: checkmarkAnimation,
    rendererSettings: {
    preserveAspectRatio: 'xMidYMid meet',
    }
};

const MFAOption: FC<MFAOptionProps> = (props) => {

    const { isHovered, handleMouseEnter, handleMouseLeave } = useHover();

    const onMFAArticleClick = () => {
        const url = "https://helpme.everlogic.com/help/edit-user-mfa-information-multi-factor-authentication";
        window.open(url, "_blank");
    };
    

    const maskPhone = (phoneNumber: string) : string => {
        return `(${phoneNumber.slice(0, 2)}*) ***-**${phoneNumber.slice(8,10)}`
    }

    const maskEmail = (email: string): string => {
        const [emailName, domain] = email.split("@");
        let maskedEmailName;

        if (emailName.length <= 2) {
            maskedEmailName = emailName.slice(0, 1) + "*".repeat(emailName.length - 1);
        } else if (emailName.length < 9) {
            maskedEmailName = emailName.slice(0, 2) + "*".repeat(emailName.length - 2);
        } else {
            maskedEmailName = emailName.slice(0, 2) + "*".repeat(6) + emailName.slice(emailName.length);
        }
        return maskedEmailName + "@" + domain;
    };

    const options = [
        ...(props.user.mfaPhone && props.user.mfaPhone.trim() !== "" && props.user.mfaPhone !=="undefined" ? [
          { value: "Text", label: "Text", icon: textIcon, info: maskPhone(props.user.mfaPhone), ID: 1 },
        ] : []),
        ...(props.user.mfaEmail && props.user.mfaEmail.trim() !== "" ? [
          { value: "Email", label: "Email", icon: emailIcon, info: maskEmail(props.user.mfaEmail), ID: 0 },
        ] : []),
      ];

    const [selectedOption, setSelectedOption] = useState(options.length !== 0 ? options[0].value : "");

    const handleOptionClick = (optionValue: string,ID:number)=> {
        setSelectedOption(optionValue);

        if(optionValue === "Email"){
            props.setFormData("OptEmailPhone",0)
        }
        else{
            props.setFormData("OptEmailPhone",1)
        }
    };
    
    useEffect(() => {

        if (selectedOption == "Text"){
            props.setFormData("OptEmailPhone",1)
        }
        else{
            props.setFormData("OptEmailPhone",0)
        }
        if(props.user.mfaEmail){
            props.setFormData("Email",props.user.mfaEmail)
        }
        if(props.user.mfaPhone){
            props.setFormData("Phone",props.user.mfaPhone)
        }
        props.setFormData("UserId",props.user.userId)

        props.setFormData("Firstname",props.user.firstName)
    });
    
    return (
        <>
        <FormHeading>Please select an MFA option</FormHeading>
            {options.map((option) => {
                if (!option.info) {
                    return null;
                }
                const isSelected = option.value === selectedOption;
                const highlightColor = isSelected ? "rgba(3, 128, 0, .4)" : "rgba(0, 0, 0, .2)";
                const borderThickness = isSelected ? "4px" : "2px";

                return (
                    <div key={option.value} style={{display:'flex', justifyContent: 'center'}}>
                        <OptionButton
                            onClick={() => handleOptionClick(option.value,option.ID)}
                            type="button"
                            >
                            <OptionContainer
                                shadowColor={highlightColor} borderThickness={borderThickness}>
                                <div className="checkmark-container">
                                    {isSelected && (
                                        <div className="checkmark-icon">
                                            <Lottie options={checkmark} />
                                        </div>
                                    )}    
                                </div>
                                <Option>  
                                    <OptionLabel>{option.label}</OptionLabel>
                                    <OptionInfo>
                                        <img className="option-icon" alt={`${option.label} button`} src={option.icon}/>
                                        <DisabledTextField
                                            variant="standard"   
                                            value={option.info} 
                                            disabled={true}
                                            InputProps={{disableUnderline: true }}
                                            sx={{ width: "150px"}}
                                            />
                                    </OptionInfo>   
                                </Option>
                        </OptionContainer>
                        </OptionButton>
                    </div>
                );
            })}
            <LoginButton
                variant='contained'
                size='large'
                disabled = {props.loginPaused ? true : false}
                type="submit"
                disableElevation>
                Send
                {props.loginPaused && (<Loading><FadeLoader color={"white"} size={7} /></Loading>)}
            </LoginButton>

            {options.length === 1 ? (
            <div style={{paddingLeft: "30px", paddingTop: '80px' }}>
                <a 
                    onMouseEnter={() => handleMouseEnter('editMFA')}
                    onMouseLeave={handleMouseLeave}
                    style={{
                        display: "flex",
                        fontSize: "12px",
                        fontWeight: "700", 
                        width: 'fit-content',  
                        cursor: "pointer",
                        textDecoration:  isHovered === 'editMFA' ? 'underline' : 'none',
                        padding:'15px 0px',
                        color: '#03a12b',
                        transition: "color 0.2s"}} 
                    onClick={onMFAArticleClick}>How to add another option
                </a>
            </div>
            ) : null}
            </>
    );
};

export default MFAOption;
